/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  /* footer extend */
  document.querySelectorAll('.footer__block--menu').forEach(function (menuBlock) {
    const header = menuBlock.querySelector('.footer__block__title');
    const content = menuBlock.querySelector('.footer__quicklinks');
  
    header.addEventListener('click', function () {
      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
      header.classList.toggle('active');
    });
  });


})();


/* Quick add - bigger tap area around the plus (14px each side, invisible); YMAL size boxes match home page widths; close size boxes once a size is picked so they don't sit over the cart drawer */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button { flex: 0 0 auto !important; width: auto !important; min-width: 0 !important; max-width: none !important; }' +
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button label { width: auto !important; min-width: 0 !important; }' +
    '.product-item .btn-add-to-cart::after { content: ""; position: absolute; top: -14px; right: -14px; bottom: -14px; left: -14px; }';
  document.head.appendChild(style);

  function closeQuickAdd() {
    document.querySelectorAll('.btn-add-to-cart.clicked').forEach(function (btn) {
      btn.classList.remove('clicked');
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('ws-preorder')) return;
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper .product__submit__add')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);
})();


/* Wait and Save sizes on product cards (07.10.26)
   Cards whose Wait and Save preorder product is live get the class .preorder-product.
   On those cards, sold-out sizes are shown as normal (not crossed out), and tapping
   one opens the product page with that size selected instead of quick adding. */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label { border: 1px solid #727272 !important; color: #000 !important; opacity: 1 !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label:hover { border-color: #000 !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label:before { display: none !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size { opacity: 1 !important; cursor: pointer; }';
  document.head.appendChild(style);

  function markSizes() {
    document.querySelectorAll('.product-item.preorder-product').forEach(function (item) {
      item.querySelectorAll('.floating-swatches-wrapper .radio__button').forEach(function (button) {
        var input = button.querySelector('input[data-single-option-selector]');
        if (!input) return;
        var soldOut = input.disabled || input.classList.contains('sold-out') || input.classList.contains('unavailable') || button.classList.contains('sold-out');
        if (soldOut && !input.classList.contains('ws-preorder')) {
          input.classList.add('ws-preorder');
          button.classList.add('ws-preorder-size');
        }
      });
    });
  }

  function goToProduct(input) {
    var item = input.closest('.product-item');
    var link = item && item.querySelector('a[data-product-link]');
    if (!link) return;
    var url = link.getAttribute('href');
    var variantId = '';
    item.querySelectorAll('.productVariant_option p').forEach(function (p) {
      if (p.getAttribute('data-name') === input.value) variantId = p.getAttribute('data-id');
    });
    if (variantId) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    window.location.href = url;
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var button = t.closest('.floating-swatches-wrapper .radio__button.ws-preorder-size');
    if (!button) return;
    var input = button.querySelector('input.ws-preorder');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    goToProduct(input);
  }, true);

  var queued = false;
  function queueMark() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; markSizes(); });
  }

  markSizes();
  document.addEventListener('DOMContentLoaded', markSizes);
  window.addEventListener('load', markSizes);
  new MutationObserver(queueMark).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Cart drawer - clicking the dimmed area outside the cart panel closes the cart.
   On desktop the dim background is the cart drawer element itself (the visible
   panel is .cart-drawer_inner), so the theme's own "click outside" check never
   fires there. This closes the cart when the click lands on the dim area. */
(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Only clicks that land on the drawer element itself...
    var drawer = target.closest('[data-cart-drawer]');
    if (!drawer) return;

    // ...and not inside the cart panel (or the upsell popup beside it)
    if (target.closest('.cart-drawer_inner, .cart_drawer_popup')) return;

    // Close the same way the cart's own X button does
    var closeButton = drawer.querySelector('.cart-drawer__close[data-cart-toggle]');
    if (window.cart && typeof window.cart.closeCartDrawer === 'function') {
      window.cart.closeCartDrawer();
    } else if (closeButton) {
      closeButton.click();
    }
  });
})();
